(function () {
    const ACC_SELECTOR = '.vcms-acc';
    let accIdCounter = 0;

    function initAccordion(root) {
        const acc = root;
        if (acc.__initialized) return;
        acc.__initialized = true;

        const allowMultiple = (acc.getAttribute('data-accordion') || 'single') === 'multiple';
        const items = Array.from(acc.querySelectorAll('.vcms-acc__item'));

        items.forEach((item, idx) => {
            const btn = item.querySelector('.vcms-acc__button');
            const panel = item.querySelector('.vcms-acc__panel');
            if (!btn || !panel) return;

            // IDs/ARIA
            const accId = acc.id || (acc.id = `v-acc-${++accIdCounter}`);
            const btnId = btn.id || (btn.id = `${accId}-btn-${idx}`);
            const panelId = panel.id || (panel.id = `${accId}-panel-${idx}`);

            btn.setAttribute('aria-controls', panelId);
            btn.setAttribute('aria-expanded', item.classList.contains('is-open') ? 'true' : 'false');
            btn.setAttribute('role', 'button');
            btn.setAttribute('type', 'button');
            btn.setAttribute('tabindex', '0');

            panel.setAttribute('role', 'region');
            panel.setAttribute('aria-labelledby', btnId);

            // Startzustand Höhe setzen (für Transition)
            requestAnimationFrame(() => {
                if (item.classList.contains('is-open')) {
                    panel.style.height = panel.scrollHeight + 'px';
                } else {
                    panel.style.height = '0px';
                }
            });

            // Toggle-Handler
            btn.addEventListener('click', () => toggleItem(item, allowMultiple));
            btn.addEventListener('keydown', (e) => {
                // Space/Enter = toggle
                if (e.key === ' ' || e.key === 'Enter') {
                    e.preventDefault();
                    toggleItem(item, allowMultiple);
                    return;
                }
                // Pfeilnavigation
                const focusables = items.map(i => i.querySelector('.vcms-acc__button')).filter(Boolean);
                const idx = focusables.indexOf(btn);
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    focusables[(idx + 1) % focusables.length].focus();
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    focusables[(idx - 1 + focusables.length) % focusables.length].focus();
                } else if (e.key === 'Home') {
                    e.preventDefault();
                    focusables[0].focus();
                } else if (e.key === 'End') {
                    e.preventDefault();
                    focusables[focusables.length - 1].focus();
                }
            });
        });

        function toggleItem(item, allowMultiple) {
            const btn = item.querySelector('.vcms-acc__button');
            const panel = item.querySelector('.vcms-acc__panel');
            const isOpen = item.classList.contains('is-open');

            if (!allowMultiple) {
                // alles schließen außer current
                Array.from(acc.querySelectorAll('.vcms-acc__item.is-open')).forEach(openItem => {
                    if (openItem !== item) close(openItem);
                });
            }

            isOpen ? close(item) : open(item);

            function open(it) {
                const b = it.querySelector('.vcms-acc__button');
                const p = it.querySelector('.vcms-acc__panel');
                it.classList.add('is-open');
                b.setAttribute('aria-expanded', 'true');
                // für saubere Transition: erst auto-Höhe berechnen
                p.style.height = p.scrollHeight + 'px';
                // nach Ende Transition auf 'auto' setzen, damit responsive Content wachsen kann
                const onEnd = (ev) => {
                    if (ev.propertyName === 'height') {
                        p.style.height = 'auto';
                        p.removeEventListener('transitionend', onEnd);
                    }
                };
                p.addEventListener('transitionend', onEnd);
            }

            function close(it) {
                const b = it.querySelector('.vcms-acc__button');
                const p = it.querySelector('.vcms-acc__panel');
                // von auto auf feste Höhe setzen, dann auf 0 animieren
                p.style.height = p.scrollHeight + 'px';
                // Force reflow
                // eslint-disable-next-line no-unused-expressions
                p.offsetHeight;
                it.classList.remove('is-open');
                b.setAttribute('aria-expanded', 'false');
                p.style.height = '0px';
            }
        }
    }

    function initAll(context = document) {
        context.querySelectorAll(ACC_SELECTOR).forEach(initAccordion);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => initAll());
    } else {
        initAll();
    }
})();
